import '../scss/index.scss';

(function () {
  'use strict';

  function pad(value) {
    return value < 10 ? '0' + value : '' + value;
  }

  function initCountdowns() {
    var banners = document.querySelectorAll('.js-aw-promocodebanner');
    Array.prototype.forEach.call(banners, function (banner) {
      var end = parseInt(banner.getAttribute('data-end'), 10);
      if (!end) {
        return;
      }

      var display = banner.querySelector('.js-aw-promocodebanner-countdown');
      if (!display) {
        return;
      }

      var daysEl = display.querySelector('[data-unit="days"]');
      var hoursEl = display.querySelector('[data-unit="hours"]');
      var minutesEl = display.querySelector('[data-unit="minutes"]');
      var secondsEl = display.querySelector('[data-unit="seconds"]');
      var timer = null;

      function tick() {
        var diff = end - Math.floor(Date.now() / 1000);
        if (diff <= 0) {
          banner.style.display = 'none';
          if (timer) {
            clearInterval(timer);
          }
          return;
        }

        var days = Math.floor(diff / 86400);
        var hours = Math.floor((diff % 86400) / 3600);
        var minutes = Math.floor((diff % 3600) / 60);
        var seconds = diff % 60;

        if (daysEl) {
          daysEl.textContent = pad(days);
        }
        if (hoursEl) {
          hoursEl.textContent = pad(hours);
        }
        if (minutesEl) {
          minutesEl.textContent = pad(minutes);
        }
        if (secondsEl) {
          secondsEl.textContent = pad(seconds);
        }
      }

      tick();
      timer = setInterval(tick, 1000);
    });
  }

  function showFeedback(button) {
    var banner = button.closest('.aw-promocodebanner');
    var copied = banner ? banner.querySelector('.aw-promocodebanner-compact__copied') : null;

    if (copied) {
      button.style.visibility = 'hidden';
      copied.classList.add('is-visible');
      setTimeout(function () {
        copied.classList.remove('is-visible');
        button.style.visibility = 'visible';
      }, 2000);

      return;
    }

    var config = window.awPromocodebanner || {};
    var label = button.querySelector('.aw-promocodebanner-code__value');
    if (!label) {
      return;
    }

    var original = label.getAttribute('data-original') || label.textContent;
    label.setAttribute('data-original', original);
    label.textContent = config.copied || 'Skopiowano!';
    button.classList.add('is-copied');

    setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-copied');
    }, 1500);
  }

  function fallbackCopy(code, button) {
    var input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      showFeedback(button);
    } catch (e) {}
    document.body.removeChild(input);
  }

  function copyCode(button) {
    var code = button.getAttribute('data-code');
    if (!code) {
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        showFeedback(button);
      }).catch(function () {
        fallbackCopy(code, button);
      });
    } else {
      fallbackCopy(code, button);
    }
  }

  function initCopy() {
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) {
        return;
      }
      var button = event.target.closest('.js-aw-promocodebanner-copy');
      if (button) {
        copyCode(button);
      }
    });
  }

  function readableTextColor(background) {
    var parts = background && background.match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
    if (!parts) {
      return null;
    }

    var r = parseInt(parts[1], 10) / 255;
    var g = parseInt(parts[2], 10) / 255;
    var b = parseInt(parts[3], 10) / 255;
    var luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    return luminance > 0.6 ? '#1b2a4e' : '#ffffff';
  }

  function initContrast() {
    var elements = document.querySelectorAll('.mrbh-card-head, .mrbh-card-code, .mrb-badge');
    Array.prototype.forEach.call(elements, function (element) {
      var color = readableTextColor(window.getComputedStyle(element).backgroundColor);
      if (color) {
        element.style.color = color;
      }
    });
  }

  function init() {
    initCountdowns();
    initCopy();
    initContrast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
